import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { purchaseOrdersPageDef } from '@/components/scm/scm-page-defs';

export default function ScmPurchaseOrdersPage() {
  return <ScmPageRenderer pageDef={purchaseOrdersPageDef} />;
}
